import { Maximize2, MoveHorizontal } from 'lucide-react';
import React, { useState } from 'react';
import { usePanelLayout } from './EditorLayoutContext';

type SidebarPanelProps = {
  title: string;
  icon: any;
  children: React.ReactNode;
  defaultCollapsed?: boolean;
  onDetach: (
    id: string,
    content: React.ReactNode,
    title: string,
    icon: any
  ) => void;
  id: string;
  isDetached: boolean;
};

export function SidebarPanel({
  title,
  icon: Icon,
  children,
  defaultCollapsed = false,
  onDetach,
  id,
  isDetached
}: SidebarPanelProps) {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);
  const { movePanel, getPanelSide } = usePanelLayout();
  const currentSide = getPanelSide(id);

  if (isDetached) return null;

  const enablePanelControls = false;

  return (
    <div className="h-full flex flex-col">
      <div className="p-4 bg-gray-50 border-b flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Icon className="w-4 h-4" />
          <h3 className="font-medium">{title}</h3>
        </div>
        {enablePanelControls && (
          <div className="flex items-center gap-1">
            <button
              onClick={() => movePanel(id)}
              className="p-1 hover:bg-gray-200 rounded-md"
              title={`Move to ${currentSide === 'left' ? 'right' : 'left'} sidebar`}
            >
              <MoveHorizontal className="w-4 h-4" />
            </button>
            <button
              onClick={() => onDetach(id, children, title, Icon)}
              className="p-1 hover:bg-gray-200 rounded-md"
              title="Detach panel"
            >
              <Maximize2 className="w-4 h-4" />
            </button>
          </div>
        )}
      </div>
      <div
        className={
          'w-full bg-background-primary flex-1 overflow-hidden transition-all duration-300'
        }
      >
        <div className={'h-full overflow-auto'}>{children}</div>
      </div>
    </div>
  );
}
